/**
 * Methods for linking between views.
 */
export default {
    methods: {
        /**
        * Item name as slug for url.
        */
        getSlugUrlName: function (item) {
            let urlName = '-';
            if (item && item.Name) {
                urlName = item.Name
                    // convert all whitespaces to "-"
                    .replace(/\s/g, '-')
                    .replace('&', '_')
                    .replace(/[^\w-åäöÅÄÖ]+/g, '')
                    // remove all non-wordchars and some exceptions
                    .replace(/\u00BF-\u1FFF\u2C00-\uD7FF\w/gi, ''); // this one is from stackoverflow
            }
            return urlName;
        },

        /**
        * Get route to an item.
        * The complex way.
        */
        getRoute: function (item, params, itemType) {
            let pathName = this.$store.getters['ux/getLocale'];
            const useProfile = this.$store.getters['ux/getUseProfile'];
            switch (itemType) {
            case 'Actor':
                pathName += '.ActorPage';
                break;
            case 'Actors':
                pathName += '.Actors';
                break;
            case 'FeatureArticle':
                pathName += '.ArticlePage';
                break;
            case 'FeatureArticles':
                pathName += '.Articles';
                break;
            case 'Artwork':
                pathName += '.ArtworkPage';
                break;
            case 'Artworks':
                pathName += '.Artworks';
                break;
            case 'Audio':
                pathName += '.AudioPage';
                // audio resource wrappers may not always carry Id, in which case route is impossible to format
                if (!item || !item.Id) {
                    return {};
                }
                break;
            case 'Audios':
                pathName += '.Audios';
                break;
            case 'Collection':
                pathName += '.CollectionPage';
                break;
            case 'Collections':
                pathName += '.Collections';
                break;
            case 'Event':
                pathName += '.EventPage';
                break;
            case 'Events':
                pathName += '.Events';
                break;
            case 'Gallery':
                pathName += '.GalleryPage';
                break;
            case 'Galleries':
                pathName += '.Galleries';
                break;
            case 'Museum':
                pathName += '.MuseumPage';
                break;
            case 'Museums':
                pathName += '.Museums';
                break;
            case 'Organization':
                pathName += '.OrganizationPage';
                break;
            case 'Organizations':
                pathName += '.Organizations';
                break;
            case 'Video':
                pathName += '.VideoPage';
                // video resource wrappers may not always carry Id, in which case route is impossible to format
                if (!item || !item.Id) {
                    return {};
                }
                break;
            case 'Videos':
                pathName += '.Videos';
                break;
            case 'Community':
                pathName += '.CommunityHome';
                break;
            default:
                // TODO: use the parameter as path name itself
                pathName = itemType;
            }

            let route;
            if (item) {
                const urlName = this.getSlugUrlName(item);

                // - displayed section can be a combination of different subpages
                // - given params override these defaults
                route = {
                    name: pathName,
                    params: _.extend({}, { // path params
                        id: (item.Id || item.ActorId),
                        urlName: urlName
                    }, params),
                    query: { // other url params (?...&...)
                        UseProfile: useProfile
                    }
                };
            }
            else {
                route = { name: pathName };
            }
            return route;
        },


        /**
        * Get route to an item.
        * The simple way.
        */
        getLocalizedRoute: function (view, locale, query = {}, params = {}) {
            let route = {};
            if (view && locale) {
                route = { name: `${locale}.${view}`, params, query };
            }
            return route;
        }
    }
};
